import React, { useEffect } from 'react';
import { IconStar } from 'design-system/icons';
import { StyleSheet, View } from 'react-native';
import Animated, { useSharedValue, withTiming, withRepeat, withDelay, useAnimatedStyle, cancelAnimation, Easing, } from 'react-native-reanimated';
import MaskedView from '@react-native-masked-view/masked-view';
import LinearGradient from 'utils/packages/linearGradient';
import { rem } from 'design-system';
const UNIT_STAR_SIZE = 16;
const STAR_SIZE = rem(UNIT_STAR_SIZE);
const STAR_GAP = rem(2);
const STAR_COUNT = 5;
const STARS_TOTAL_WIDTH = STAR_SIZE * STAR_COUNT + STAR_GAP * (STAR_COUNT - 1);
const SHIMMER_WIDTH = STARS_TOTAL_WIDTH * 0.5;
const SHIMMER_DURATION = 1500;
const SHIMMER_DELAY = 50;
const Shimmer = ({ style, animate = false, repeatCount = -1, }) => {
    const translateX = useSharedValue(-SHIMMER_WIDTH);
    useEffect(() => {
        if (animate) {
            translateX.value = withDelay(SHIMMER_DELAY, withRepeat(withTiming(STARS_TOTAL_WIDTH, {
                duration: SHIMMER_DURATION,
                easing: Easing.inOut(Easing.ease),
            }), repeatCount, false));
        }
        else {
            cancelAnimation(translateX);
            translateX.value = -SHIMMER_WIDTH;
        }
        return () => {
            cancelAnimation(translateX);
            translateX.value = -SHIMMER_WIDTH;
        };
    }, [animate, repeatCount, translateX]);
    const shimmerStyle = useAnimatedStyle(() => ({
        transform: [{ translateX: translateX.value }],
    }));
    const stars = (<View style={{ flexDirection: 'row', alignItems: 'center', gap: STAR_GAP }}>
      {Array.from({ length: STAR_COUNT }).map((_, index) => (<IconStar width={STAR_SIZE} height={STAR_SIZE} key={index}/>))}
    </View>);
    return (<View style={style}>
      <MaskedView style={{ width: STARS_TOTAL_WIDTH, height: STAR_SIZE }} maskElement={stars}>
        <View style={{ width: STARS_TOTAL_WIDTH, height: STAR_SIZE }}>
          <Animated.View style={[StyleSheet.absoluteFill, shimmerStyle]} pointerEvents="none">
            <LinearGradient colors={[
            'rgba(255,255,255,0)',
            'rgba(255,255,255,0.55)',
            'rgba(255,255,255,0)',
        ]} start={{ x: 0, y: 0.5 }} end={{ x: 1, y: 0.5 }} style={{ width: SHIMMER_WIDTH, height: '100%' }}/>
          </Animated.View>
        </View>
      </MaskedView>
    </View>);
};
const ShimmeringStars = ({ animate = false, repeatCount = -1, }) => (<View style={styles.starsContainer}>
    <Shimmer animate={animate} repeatCount={repeatCount} style={styles.shimmer}/>
    {Array.from({ length: STAR_COUNT }).map((_, index) => (<IconStar width={UNIT_STAR_SIZE} height={UNIT_STAR_SIZE} key={index}/>))}
  </View>);
const styles = StyleSheet.create({
    starsContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: STAR_GAP,
        marginVertical: rem(8),
    },
    shimmer: {
        position: 'absolute',
        left: 0,
        top: 0,
        zIndex: 1,
    },
});
export default ShimmeringStars;
